import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import SearchInput from "../UI/SearchInput";

interface ListHeaderProps {
  title: string;
  search?: {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    loading?: boolean;
    disabled?: boolean;
  };
  onCreate?: () => void;
  createLabel?: string;
  children?: React.ReactNode;
}

const ListHeader: React.FC<ListHeaderProps> = ({
  title,
  search,
  onCreate,
  createLabel = "Add New",
  children,
}) => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
        mb={2}
      >
        <Stack direction="row" spacing={2} flex={1} minWidth={300}>
          {search && (
            <SearchInput
              value={search.value}
              onChange={search.onChange}
              placeholder={search.placeholder || "Search..."}
              loading={search.loading}
              disabled={search.disabled}
            />
          )}

          {children}
        </Stack>

        {onCreate && (
          <Button
            variant="contained"
            onClick={onCreate}
            sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
          >
            {createLabel}
          </Button>
        )}
      </Box>
    </>
  );
};

export default ListHeader;
